import { render, staticRenderFns } from "./RegistrationDocumentsInformation.vue?vue&type=template&id=2e143f9f&scoped=true"
import script from "./RegistrationDocumentsInformation.vue?vue&type=script&lang=js"
export * from "./RegistrationDocumentsInformation.vue?vue&type=script&lang=js"
import style0 from "./RegistrationDocumentsInformation.vue?vue&type=style&index=0&id=2e143f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e143f9f",
  null
  
)

export default component.exports